<template>
    <button 
        :disabled="this.sound.detections.length === 0" 
        class="button slightly-rounded m-2" 
        @click="downloadTextFileEvent('csv', 'text/csv')"
    >
        <span>Download Detections</span>
        <span class="icon"><i class="fa-solid fa-file-csv"></i></span>
    </button>
</template>

<script>
import { JSONtoCSV, addColumns, removeFileExtension, saveTextFileLocally } from '@/js/general.js'
export default {
    name: 'DownloadDetectionsButton',
    props: ['sound'],
    methods: {
        downloadTextFileEvent(fileType, mimeType){
            // log the event info
            console.log(
                "downloadCSVFileEvent",
                this.sound.requesting_user,
                this.sound.id,
            )
            // validate that there are detections
            if (this.sound.detections.length > 0) {
                // prep the file name
                const textFileName = removeFileExtension(this.sound.fileName)
                // add the sound file name column to the detections data
                const detections = addColumns(this.sound.detections, {'file_name': this.sound.fileName})        
                // convert the file from json to tsv
                const file = JSONtoCSV(detections, ['file_name', 'specie', 'common_name', 'start', 'end', 'location', 'confidence'])
                // download the file
                saveTextFileLocally(file, textFileName, fileType, mimeType)    
            } else {
                console.log('No detections available')
            }
        },
    }
}
</script>

